<template>
  <form @submit.prevent="updateDiscount" method="POST">
    <input type="hidden" name="action" value="commerce/cart/updateCart">
    <input type="hidden" name="redirect" value="shop/cart">
    <input type="hidden" :name="$root.$options.csrf.name" :value="$root.$options.csrf.value">

    <label class="text-grey-darkest" :class="{ 'text-red': errorMessage }" for="couponcode">Discount Code</label>
    <div class="flex items-end">
      <input
        v-model.lazy.trim="couponCode"
        @change="updateDiscount"
        type="text"
        name="couponCode"
        id="couponcode"
        class="w-full border-0 border-b border-orange px-2 mx-0 mb-2">

      <input
        v-if="couponCode !== ''"
        @click="updateDiscount"
        type="submit"
        class="btn mb-2 ml-2 text-sm px-4 py-2"
        value="Change">
      <input
        v-else
        @click="updateDiscount"
        type="submit"
        class="btn mb-2 ml-2 text-sm px-4 py-2"
        value="Apply">
    </div>

    <transition name="fade">
      <span v-if="errorMessage" class="text-red">{{ errorMessage }}</span>
      <span v-if="success && couponCode !== ''" class="text-green-dark">Discount Applied</span>
    </transition>
  </form>
</template>

<script>
import axios from "axios"
import { EventBus } from "../../lib/event-bus.js"

export default {
  props: {
    error: {
      default: null
    },
    currentCoupon: {
      default: null
    }
  },

  data() {
    return {
      couponCode: this.currentCoupon || '',
      errorMessage: this.error || null,
      success: false
    }
  },

  methods: {
    updateDiscount() {
      this.errorMessage = null
      this.success = false

      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      params.append(this.$root.$options.csrfTokenName, this.$root.$options.csrf.value);
      params.append('action', 'commerce/cart/updateCart');
      params.append('couponCode', this.couponCode);

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        console.log('Coupon success:', response);
        const cart = response.data.cart;

        if (cart.errors && cart.couponCode.length) {
          this.errorMessage = cart.errors.couponCode[0]
        } else {
          this.success = true
          EventBus.$emit('qty-update');

          setTimeout(() =>{
            this.success = false
          }, 4000)
        }
      })
      .catch((error) => {
        console.log('Qty Form Error:', error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/DiscountCode.vue